import { useEffect, useState } from 'react'

import { getSchoolOnboardingEligibility } from 'api/school-onboarding'

export const SCHOOL_WELCOME_PATH = '/app-v2/onboarding/school'
export const SCHOOL_WELCOME_POSTPONED_KEY = 'school-welcome-postponed'
export const SCHOOL_WELCOME_NOT_ELIGIBLE_KEY = 'school-welcome-not-eligible'

type SchoolWelcomeRedirectState = {
  redirectTo: string | null
  loading: boolean
}

const readSession = (key: string): boolean => {
  try {
    return sessionStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

const writeSession = (key: string) => {
  try {
    sessionStorage.setItem(key, '1')
  } catch {
    return
  }
}

const shouldSkipCheck = () =>
  readSession(SCHOOL_WELCOME_POSTPONED_KEY) ||
  readSession(SCHOOL_WELCOME_NOT_ELIGIBLE_KEY)

export const useSchoolWelcomeRedirect = (
  enabled: boolean
): SchoolWelcomeRedirectState => {
  const [state, setState] = useState<SchoolWelcomeRedirectState>(() => ({
    redirectTo: null,
    loading: enabled && !shouldSkipCheck()
  }))

  useEffect(() => {
    if (!enabled || shouldSkipCheck()) {
      setState({ redirectTo: null, loading: false })
      return
    }

    let cancelled = false
    setState({ redirectTo: null, loading: true })

    getSchoolOnboardingEligibility()
      .then(response => {
        if (cancelled) return
        if (response.data.eligible) {
          setState({ redirectTo: SCHOOL_WELCOME_PATH, loading: false })
          return
        }
        writeSession(SCHOOL_WELCOME_NOT_ELIGIBLE_KEY)
        setState({ redirectTo: null, loading: false })
      })
      .catch(() => {
        if (!cancelled) {
          setState({ redirectTo: null, loading: false })
        }
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return state
}
